import DefaultMessage from "components/Common/DefaultMessage/DefaultMessage.tsx";
import TableSkeleton from "components/Common/Table/TableSkeleton/TableSkeleton.tsx";
import { useGetOrderUpdatesQuery } from "features/api/orderApi.ts";
import { ActionItemsTable } from "./components/ActionItemsTable.tsx";
import {
	ActionItemsPageContainer,
	ActionItemsPageContent,
	ActionItemsPageContentContainer,
	ActionItemsPageHeader,
	ActionItemsPageHelperText,
	ActionItemsTableContainer
} from "./ActionItemsPage.styles.ts";
import * as Text from "./ActionItemsPage.text.ts";

export const ActionItemsPage = () => {
	const { data: actionItems = [], isLoading } = useGetOrderUpdatesQuery();

	const renderContent = () => {
		if (isLoading) return <TableSkeleton />;

		if (!actionItems.length) {
			return (
				<DefaultMessage
					dataTestId="default-message-no-action-items"
					asset="/assets/NoOrdersSadBoxImage.svg"
					altMessage="No action items available"
					title={Text.NoActionItemsText}
					subtitle={Text.NoActionItemsSubText}
					removeHeight
				/>
			);
		}

		return (
			<>
				<ActionItemsPageHelperText>{Text.ActionItemsHelperText}</ActionItemsPageHelperText>
				<ActionItemsTableContainer>
					<ActionItemsTable actionItems={actionItems} />
				</ActionItemsTableContainer>
			</>
		);
	};

	return (
		<ActionItemsPageContainer>
			<ActionItemsPageHeader title={Text.ActionItemsTitleText} />
			<ActionItemsPageContentContainer>
				<ActionItemsPageContent>{renderContent()}</ActionItemsPageContent>
			</ActionItemsPageContentContainer>
		</ActionItemsPageContainer>
	);
};
